import { FC } from "react";
import { usePersonalCodeContext } from "./context";
import { Text } from '@constructor/components';

const PersonalBonusCode: FC = (props) => {

    const code = usePersonalCodeContext();

    if (!code) {
        return null;
    }

    return (
        <Text text={code.code} {...props} />
    )
}

export default PersonalBonusCode;